import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { GridFormatterService } from "../../../../common/services/grid-formatter.service";
import { SubHeaderService } from "../../../../core/services/sub-header.service";
import { DynamicDialogService } from "../../../../core/services/dynamic-dialog.service";
import { DatePipe } from "@angular/common";
import { SubHeader } from "../../../../core/models/sub-header.model";
import { ColDef, GridOptions, GridReadyEvent, IServerSideGetRowsParams, ITextFilterParams, LoadSuccessParams, GridApi, IDateFilterParams } from 'ag-grid-community';
import { GISPoint, GISPointTypes, WellPermittingModifiers, WellsRequiringFA } from "../../../../common/models/well.model";
import { AuthService } from "../../../../services/auth.service";
import { CheckboxRendererComponent } from "../../../../common/components/ag-grid/checkbox-renderer.component";
import { RouterLinkRendererComponent } from "../../../../common/components/ag-grid/router-link-renderer.component";
import { combineLatest, Observable, Subscription } from "rxjs";
import { NavigationStart, Router, RouterLink } from "@angular/router";
import { OrderParameters, PagedWellSearchSpec, WellService } from "../../../../common/services/well.service";

import { filter, take, tap } from "rxjs/operators";
import { dateComparator } from "../../../../common/components/data-table/comparators/data-table.comparators";
import { AgGridBooleanFilterComponent, IBooleanFilterParams } from "../../../../common/components/ag-grid/filters/boolean-filter.component";
import { DomainValue } from "../../../../models/domain.model";
import { WellDirection } from "../../../../form-controls/components/new-casing-plan/models/casing-plan.model";
import { DomainDefinitionService } from "../../../../builder/services/domain-definition.service";
import { FlaggedComponent } from '../../../../common/components/data-table/columns/flagged/flagged.component';
import { LoaderService } from "../../../../common/services/loader.service";



@Component({
    selector: 'app-wells-requiring-bonding-insurance-report',
    templateUrl: './wells-requiring-bonding-insurance-report.html',
    styleUrls: ['./wells-requiring-bonding-insurance-report.scss'],
    standalone: false
})

export class WellsRequiringBondingInsuranceReportComponent implements OnInit, OnDestroy {

    subheader: SubHeader = new SubHeader({ title: 'Wells Requiring Bonding or Insurance', buttons: [{ name: "Export", method: () => this.exportAllData() }] })
    form: FormGroup;
    frameworkComponents: any;
    data: WellsRequiringFA[] = [];
    loading: boolean = false
    dataSubscriptions: Subscription = new Subscription();
    gridReady: boolean;
    gridOptions: GridOptions;
    gridApi: GridApi;
    wellsDataSource: WellsDataSource;
    public searchSpec: PagedWellSearchSpec = {} as PagedWellSearchSpec;
    _booleanfilterParams = { isInServerSideFilterMode: true} as IBooleanFilterParams;
    _allWellTypeDescriptionDomainValues: DomainValue[];
    _allWellDispositionDomainValues: DomainValue[];
    _allWellDispositionLegacyTrackingValues: DomainValue[];
    _allWellTypeDomainValues: DomainValue[];
    dispositions: string[] = [];
    statusObs$: Observable<DomainValue[]>;
    typeObs$: Observable<DomainValue[]>;
    descObs$: Observable<DomainValue[]>;
    reasonObs$: Observable<DomainValue[]>;
    formationsObs$: Observable<DomainValue[]>;

    _formations: DomainValue[]; //probably don't need this one
    _textFilterParams = {
        filterOptions: ['equals', 'contains', 'startsWith', 'endsWith'],
        suppressAndOrCondition: true,
        buttons: ['reset'],
    } as ITextFilterParams;
    _domainsLoaded: boolean = false;



    constructor(
        private subHeaderService: SubHeaderService, private formatter: GridFormatterService, private dialog: DynamicDialogService,
        private datePipe: DatePipe, private wellService: WellService, private domainService: DomainDefinitionService, private loader: LoaderService
    ) {
   
        if (this.searchSpec == null || this.searchSpec == undefined)
            this.searchSpec = {} as PagedWellSearchSpec;


    }

    get excelStyles(): any[] {
        if (this.formatter) return this.formatter.excelStyles;
        return [];
    }

    ngOnInit() {
        this.subHeaderService.updateSubHeader(this.subheader);
        this.typeObs$ = this.domainService.getValues("WELL_TYP").pipe(tap((domains: DomainValue[]) => {
            if (domains) this._allWellTypeDomainValues = domains;
        }));

        this.descObs$ = this.domainService.getValues("WLTYP_DESC").pipe(tap((domains: DomainValue[]) => {
            if (domains) this._allWellTypeDescriptionDomainValues = domains;


        }));

        this.statusObs$ = this.domainService.getValues("STATUS_DESC").pipe(tap((domains: DomainValue[]) => {
            if (domains) {
                this._allWellDispositionDomainValues = domains;
                // Add a blank option at the start
                let blankOption = { Code: '', Definition: '' } as DomainValue
                this._allWellDispositionDomainValues.unshift(blankOption)

            }

        }));

        this.reasonObs$ = this.domainService.getValues("STATUS_REAS").pipe(tap((domains: DomainValue[]) => {
            if (domains) {
                this._allWellDispositionLegacyTrackingValues = domains;
            }
        }));

        this.formationsObs$ = this.domainService.getValues("FORMATION").pipe(tap((domains: DomainValue[]) => {
            if (domains) this._formations = domains;
        }));

        let dataSubs$ = combineLatest([this.typeObs$, this.descObs$, this.statusObs$, this.reasonObs$, this.formationsObs$]).pipe(
        ).subscribe(() => {

            this.gridReady = true;
        }, (error) => { console.error(error); });

        this.dataSubscriptions.add(dataSubs$);


        this.gridOptions = this.formatter.BuildDefaultGridOptionsWithColumns(this.buildColumns(), true);
        this.gridOptions.rowModelType = 'serverSide';
        this.gridOptions.cacheBlockSize = 100;
        this.gridOptions.maxBlocksInCache = 2;
        this.gridOptions.suppressMultiSort;
        this.gridOptions.onGridReady = (params: GridReadyEvent) => {
            this.onGridReady(params);
            this.gridApi.sizeColumnsToFit();
        }
    }

    ngOnDestroy() {
        this.dataSubscriptions.unsubscribe();
    }

    onGridReady(params: GridReadyEvent) {
        this.wellsDataSource = new WellsDataSource(this.wellService, this._allWellDispositionDomainValues, this._allWellTypeDomainValues, this._allWellTypeDescriptionDomainValues, this._allWellDispositionLegacyTrackingValues, this._formations, this.searchSpec);
        this.gridApi = params.api;
        this.gridApi.setGridOption("serverSideDatasource", this.wellsDataSource);
    }

    buildColumns(): ColDef[] {
        return [
            {
                headerName: 'API #',
                field: 'id',
                cellRenderer: RouterLinkRendererComponent,
                cellRendererParams: {
                    openInNewWindow: true,
                    textField: 'id',
                    url: (data: any) => `/dashboard/view/well/${data.id}`
                },
                headerClass: "wrapped",
                headerTooltip: 'API #',
                tooltipField: 'id',
                filter: "agTextColumnFilter",
                filterParams: this._textFilterParams,
                minWidth: 130,
                cellClass: "stringType"
            },
            {
                headerName: 'Well Name',
                field: 'name',
                tooltipValueGetter: this.formatter.formatPotentiallyBlankField('name', 'N/A'),
                valueGetter: this.formatter.formatPotentiallyBlankField('name', 'N/A'),
                valueFormatter: this.formatter.formatPotentiallyBlankField('name', 'N/A'),
                filter: "agTextColumnFilter",
                filterParams: this._textFilterParams,
                minWidth: 150,
                headerClass: "wrapped",
                headerTooltip: 'Well Name'
            },
            {
                headerName: 'Well Number',
                field: 'wellNumber',
                tooltipValueGetter: this.formatter.formatPotentiallyBlankField('wellNumber', 'N/A'),
                valueGetter: this.formatter.formatPotentiallyBlankField('wellNumber', 'N/A'),
                valueFormatter: this.formatter.formatPotentiallyBlankField('wellNumber', 'N/A'),
                filter: "agTextColumnFilter",
                filterParams: this._textFilterParams,
                minWidth: 140,
                headerClass: "wrapped",
                headerTooltip: 'Well Number'
            },
            {
                headerName: 'Well Disposition',
                headerTooltip: 'Well Disposition',
                headerClass: "wrapped",
                field: 'disposition',
                filter: 'agSetColumnFilter',
                filterParams: {
                    values: (params: any) => this.statusObs$.pipe().subscribe(domains => {
                        var defs = domains.map(d => d.Definition);
                        params.success(defs);
                    }),
                },
                minWidth: 130
            },
            {
                headerName: 'Legacy Tracking',
                headerTooltip: 'Legacy Tracking',
                headerClass: "wrapped",
                field: 'legacyTracking',
                filter: 'agSetColumnFilter',
                filterParams: {
                    values: (params: any) => this.reasonObs$.pipe().subscribe(domains => {
                        var defs = domains.map(d => d.Definition);
                        params.success(defs);
                    }),
                    suppressSelectAll: false //i think this works, if not i've no clue why this one doesn't work
                },

                minWidth: 130
            },
            {
                headerName: 'Owner Name',
                field: 'organizationName',
                filter: "agTextColumnFilter",
                filterParams: this._textFilterParams,
                minWidth: 150,
                headerClass: "wrapped",
                headerTooltip: 'Owner Name'
            },
            {
                headerName: 'Owner Number',
                field: 'organizationId',
                filter: "agTextColumnFilter",
                filterParams: this._textFilterParams,
                minWidth: 145,
                headerClass: "wrapped",
                headerTooltip: 'Owner Number'
            },
            {
                headerName: 'County Name',
                field: 'countyName',
                filter: "agTextColumnFilter",
                filterParams: this._textFilterParams,
                minWidth: 135,
                headerClass: "wrapped",
                headerTooltip: 'County Name'
            },
            {
                headerName: 'Township Name',
                field: 'townshipName',
                filter: "agTextColumnFilter",
                filterParams: this._textFilterParams,
                minWidth: 150,
                headerClass: "wrapped",
                headerTooltip: 'Township Name'
            },
            {
                headerName: 'Tract < 5 Acres',
                field: 'tract',
                filter: AgGridBooleanFilterComponent,
                filterParams: this._booleanfilterParams,
                minWidth: 150,
                headerClass: "wrapped",
                headerTooltip: 'Tract < 5 Acres',
                valueFormatter: this.formatter.formatBooleanToYesNo('tract')
            },
            {
                headerName: 'Release of Leases',
                field: 'releaseOfLeases',
                filter: AgGridBooleanFilterComponent,
                filterParams: this._booleanfilterParams,
                minWidth: 160,
                headerClass: "wrapped",
                headerTooltip: 'Release of Leases',
                valueFormatter: this.formatter.formatBooleanToYesNo('releaseOfLeases')
            },
            {
                headerName: 'Permitted Urban',
                field: 'permittedUrban',
                filter: AgGridBooleanFilterComponent,
                filterParams: this._booleanfilterParams,
                minWidth: 150,
                headerClass: "wrapped",
                headerTooltip: 'Permitted Urban',
                valueFormatter: this.formatter.formatBooleanToYesNo('permittedUrban')
            },
            {
                headerName: 'Urban',
                field: 'isUrban',
                filter: AgGridBooleanFilterComponent,
                filterParams: this._booleanfilterParams,
                minWidth: 100,
                headerClass: "wrapped",
                headerTooltip: 'Urban',
                valueFormatter: this.formatter.formatBooleanToYesNo('isUrban')
            },
            {
                headerName: 'Horizontal',
                field: 'isHorizontal',
                filter: AgGridBooleanFilterComponent,
                filterParams: this._booleanfilterParams,
                minWidth: 125,
                headerClass: "wrapped",
                headerTooltip: 'Horizontal',
                valueFormatter: this.formatter.formatBooleanToYesNo('isHorizontal')
            },
            {
                headerName: 'Slant',
                field: 'slant',
                filter: "agSetColumnFilter",
                filterParams: {
                    values: ['Directional', 'Vertical', 'Horizontal'],
                    buttons: ['reset']
                },
                minWidth: 100,
                headerClass: "wrapped",
                headerTooltip: 'Slant'
            },
            {
                headerName: "Drilling Unit Acres",
                field: "acresInDrillingUnit",
                filter: "agNumberColumnFilter",
                filterParams: {
                    filterOptions: ['equals', 'notEqual', 'lessThan', 'lessThanOrEqual', 'greaterThan', 'greaterThanOrEqual'],
                    buttons: ['reset']
                },
                minWidth: 125,
                headerClass: "wrapped",
                headerTooltip: 'Drilling Unit Acres'
            },
            {
                headerName: "H2S Area",
                field: "h2sGasPresent",
                filter: AgGridBooleanFilterComponent,
                filterParams: this._booleanfilterParams,
                minWidth: 125,
                headerClass: "wrapped",
                headerTooltip: 'H2S Area',
                valueFormatter: this.formatter.formatBooleanToYesNo('h2sGasPresent')
            },
            {
                headerName: 'Well Type',
                field: 'wellType',
                filter: 'agSetColumnFilter',
                filterParams: {
                    values: (params: any) => this.typeObs$.pipe().subscribe(domains => {
                        var defs = domains.map(d => d.Definition);
                        params.success(defs);
                    }),
                    buttons: ['reset']
                },
                minWidth: 115,
                headerClass: "wrapped",
                headerTooltip: 'Well Type'
            },
            {
                headerName: 'Well Type Description',
                field: 'wellTypeDescription',
                filter: "agSetColumnFilter",
                filterParams: {
                    values: (params: any) => this.descObs$.pipe().subscribe(domains => {
                        var defs = domains.map(d => d.Definition);
                        params.success(defs);
                    }),
                    buttons: ['reset']
                },
                minWidth: 165,
                headerClass: "wrapped",
                headerTooltip: 'Well Type Description'
            },
            {
                headerName: 'Target Formation',
                field: "proposedFormation",
                filter: "agSetColumnFilter",
                filterParams: {
                    values: (params: any) => this.formationsObs$.pipe().subscribe(domains => {
                        var defs = domains.map(d => d.Definition);
                        params.success(defs);
                    }),
                    buttons: ['reset']
                },
                minWidth: 155,
                headerClass: "wrapped",
                headerTooltip: 'Target Formation'
            },
            {
                headerName: 'Deepest Formation',
                field: "deepestFormationPenetrated",
                filter: "agSetColumnFilter",
                filterParams: {
                    values: (params: any) => this.formationsObs$.pipe().subscribe(domains => {
                        var defs = domains.map(d => d.Definition);
                        params.success(defs);
                    }),
                    buttons: ['reset']
                },
                minWidth: 165,
                headerClass: "wrapped",
                headerTooltip: 'Deepest Formation'
            },
            {
                headerName: 'Date Spud',
                field: 'dateOfOriginalSpud',
                filter: "agDateColumnFilter",
                filterValueGetter: 'dateOfOriginalSpud',
                tooltipValueGetter: this.formatter.formatDate("dateOfOriginalSpud", "MM/dd/yyyy", 'N/A', '+0000'),
                valueFormatter: this.formatter.formatDate("dateOfOriginalSpud", "MM/dd/yyyy", 'N/A', '+0000'),
                comparator: dateComparator,
                minWidth: 155,
                filterParams: {
                    filterOptions: ['equals', 'lessThan', 'greaterThan'],
                    suppressAndOrCondition: true,
                    buttons: ['reset'],
                    includeTime: false
                } as IDateFilterParams,
                headerClass: "wrapped",
                headerTooltip: 'Date Spud'
            },
            {
                headerName: 'Date T.D.',
                field: 'dateTotalDepthReached',
                filterValueGetter: 'dateTotalDepthReached',
                tooltipValueGetter: this.formatter.formatDate("dateTotalDepthReached", "MM/dd/yyyy", 'N/A', '+0000'),
                valueGetter: this.formatter.formatDate("dateTotalDepthReached", "MM/dd/yyyy", 'N/A', '+0000'),
                comparator: dateComparator,
                filter: "agDateColumnFilter",
                minWidth: 155,
                filterParams: {
                    filterOptions: ['equals', 'lessThan', 'greaterThan'],
                    suppressAndOrCondition: true,
                    buttons: ['reset'],
                    includeTime: false
                } as IDateFilterParams,
                headerClass: "wrapped",
                headerTooltip: 'Date T.D.'
            },
            {
                headerName: 'Plugback Date',
                field: 'dateOfPlugBack',
                filterValueGetter: 'dateOfPlugBack',
                tooltipValueGetter: this.formatter.formatDate('plugging.dateOfPlugBack', "MM/dd/yyyy", "N/A", "+0000"),
                valueGetter: this.formatter.formatDate('plugging.dateOfPlugBack', 'MM/dd/yyyy', 'N/A', '+0000'),
                comparator: dateComparator,
                filter: "agDateColumnFilter",
                minWidth: 155,
                filterParams: {
                    filterOptions: ['equals', 'lessThan', 'greaterThan'],
                    suppressAndOrCondition: true,
                    buttons: ['reset'],
                    includeTime: false
                } as IDateFilterParams,
                headerClass: "wrapped",
                headerTooltip: 'Plugback Date'
            },
            {
                headerName: 'Prod Date',
                field: 'productionDateOfProduction',
                filterValueGetter: 'ProductionDateOfProduction',
                tooltipValueGetter: this.formatter.formatDate('production.dateOfProduction', "MM/dd/yyyy", "N/A", "+0000"),
                valueGetter: this.formatter.formatDate('production.dateOfProduction', 'MM/dd/yyyy', 'N/A', '+0000'),
                comparator: dateComparator,
                filter: "agDateColumnFilter",
                minWidth: 155,
                filterParams: {
                    filterOptions: ['equals', 'lessThan', 'greaterThan'],
                    suppressAndOrCondition: true,
                    buttons: ['reset'],
                    includeTime: false
                } as IDateFilterParams,
                headerClass: "wrapped",
                headerTooltip: 'Prod Date'
            },
            {
                headerName: 'Date P&A',
                field: 'datePluggedAndAbandoned',
                tooltipValueGetter: this.formatter.formatDate("plugging.datePluggedAndAbandoned", "MM/dd/yyyy", 'N/A', '+0000'),
                valueGetter: this.formatter.formatDate("plugging.datePluggedAndAbandoned", "MM/dd/yyyy", "N/A", "+0000"),
                filterValueGetter: 'DatePluggedAndAbandoned',
                comparator: dateComparator,
                filter: "agDateColumnFilter",
                minWidth: 155,
                filterParams: {
                    filterOptions: ['equals', 'lessThan', 'greaterThan'],
                    suppressAndOrCondition: true,
                    buttons: ['reset'],
                    includeTime: false
                } as IDateFilterParams,
                headerClass: "wrapped",
                headerTooltip: 'Date P&A'
            },
            {
                headerName: "Plug Report Received From Operator",
                field: "plugReportReceivedFromOperator",
                valueFormatter: this.formatter.formatBooleanToYesNo("plugReportReceivedFromOperator"),
                tooltipValueGetter: this.formatter.formatBooleanToYesNo("plugReportReceivedFromOperator"),
                filter: AgGridBooleanFilterComponent,
                filterParams: this._booleanfilterParams,
                minWidth: 170,
                headerClass: "wrapped",
                headerTooltip: 'Plug Report Received From Operator'
            },
            {
                headerName: 'Driller T.D.',
                field: 'drillersMeasuredVerticalDepth',
                filter: "agNumberColumnFilter",
                filterParams: {
                    filterOptions: ['equals', 'notEqual', 'lessThan', 'lessThanOrEqual', 'greaterThan', 'greaterThanOrEqual'],
                    buttons: ['reset']
                },
                minWidth: 120,
                headerClass: "wrapped",
                headerTooltip: 'Driller T.D.'
            },
            {
                headerName: 'Logger T.D.',
                field: 'loggerMeasuredVerticalDepth',
                filter: "agNumberColumnFilter",
                filterParams: {
                    filterOptions: ['equals', 'notEqual', 'lessThan', 'lessThanOrEqual', 'greaterThan', 'greaterThanOrEqual'],
                    buttons: ['reset']
                },
                minWidth: 120,
                headerClass: "wrapped",
                headerTooltip: 'Logger T.D.'
            },
            {
                headerName: "Wellhead Latitude",
                field: "latitude83",
                filter: "agNumberColumnFilter",
                filterParams: {
                    filterOptions: ['equals', 'notEqual', 'lessThan', 'lessThanOrEqual', 'greaterThan', 'greaterThanOrEqual'],
                    buttons: ['reset']
                },
                minWidth: 150,
                headerClass: "wrapped",
                headerTooltip: 'Wellhead Latitude'
            },
            {
                headerName: "Wellhead Longitude",
                field: "longitude83",
                filter: "agNumberColumnFilter",
                filterParams: {
                    filterOptions: ['equals', 'notEqual', 'lessThan', 'lessThanOrEqual', 'greaterThan', 'greaterThanOrEqual'],
                    buttons: ['reset']
                },
                minWidth: 150,
                headerClass: "wrapped",
                headerTooltip: 'Wellhead Longitude'
            },
            {
                headerName: "Requires Bonding",
                field: "requiresBonding",
                tooltipValueGetter: this.formatter.formatBooleanToYesNo("requiresBonding"),
                filterValueGetter: this.formatter.formatBooleanToYesNo("requiresBonding"),
                valueFormatter: this.formatter.formatBooleanToYesNo("requiresBonding"),
                filter: AgGridBooleanFilterComponent,
                filterParams: { buttons: ['reset'] },
                editable: false,
                suppressMovable: true,
                minWidth: 125,
                sortable: false,
                headerClass: "wrapped"
            },
            {
                headerName: "Requires Insurance",
                field: "requiresInsurance",
                tooltipValueGetter: this.formatter.formatBooleanToYesNo("requiresInsurance"),
                filterValueGetter: this.formatter.formatBooleanToYesNo("requiresInsurance"),
                valueFormatter: this.formatter.formatBooleanToYesNo("requiresInsurance"),
                filter: AgGridBooleanFilterComponent,
                filterParams: { buttons: ['reset'] },
                editable: false,
                suppressMovable: true,
                minWidth: 125,
                sortable: false,
                headerClass: "wrapped"
            },
            {
                headerName: "Buyer FA", 
                field: "hasBuyerFA", 
                cellRenderer: FlaggedComponent, 
                sortable: false, 
                tooltipValueGetter: this.buyerLacksFA("hasBuyerFA"),
                cellRendererParams: { values: 'icon-blocked' }, 
                filter: AgGridBooleanFilterComponent, 
                filterParams: { ...this._booleanfilterParams, buttons: ['reset'] }, 
                minWidth: 120, 
                headerClass: "wrapped", 
                headerTooltip: 'Buyer FA'
            }
        ];
    }

    //formatters
buyerLacksFA(field: string): any {
    return (obj: any) => {
        const value = obj.data ? obj.data.hasBuyerFA : obj.value;
        if (value === true) return "Buyer Lacks Necessary FA";
        if (value === false) return "Buyer Has Necessary FA";
        return "N/A";
    }
}

    //exporting

    export(): void {
        const now = this.datePipe.transform(new Date(), "yyyy-MM-dd").toString();
        let fileName = 'Wells_Requiring_FA_Report';
        fileName = `${fileName}_${now}`;
        this.formatter.exportDataToExcel(fileName, 'Wells', this.gridApi, false);
    }

    async exportAllData(): Promise<void> {
        this.loading = true;
        this.loader.toggleLoader(this.loading);
        const pageSize = 1000;
        let allRows: WellsRequiringFA[] = [];
        let rowNum = 0;
        let totalRows = 0;

        // Use the same filtering logic as the grid
        const dataSource = new WellsDataSource(
            this.wellService,
            this._allWellDispositionDomainValues,
            this._allWellTypeDomainValues,
            this._allWellTypeDescriptionDomainValues,
            this._allWellDispositionLegacyTrackingValues,
            this._formations,
            { ...this.searchSpec }
        );

        // Build a minimal IServerSideGetRowsParams for each page
        let keepGoing = true;
        try {
            do {
                const params: IServerSideGetRowsParams = {
                    request: {
                        startRow: rowNum,
                        endRow: rowNum + pageSize,
                        filterModel: this.gridApi ? this.gridApi.getFilterModel() : {},
                        sortModel: [],
                        rowGroupCols: [],
                        valueCols: [],
                        pivotCols: [],
                        pivotMode: false,
                        groupKeys: []
                    },
     //               successCallback: (rows: WellsRequiringFA[], count: number) => {
     //                   allRows = allRows.concat(rows);
     //                   totalRows = count;
					//},
					success: (params: LoadSuccessParams) => {
						allRows = allRows.concat(params.rowData);
						totalRows = params.rowCount ?? 0;
					},					
					//failCallback: () => {  },
					fail: () => {  },
					parentNode: undefined as any,
					api: this.gridApi,
					context: null,
					needsGrandTotal: false
                };

                // getRows is sync, but the actual data fetch is async, so we mimic the logic
                await new Promise<void>((resolve) => {
                    // Patch the dataSource to call resolve after data is fetched
                    const origSuccess = params.success;
                    params.success = (params) => {
						origSuccess(params);
                        resolve();
                    };
                    dataSource.getRows(params);
                });
                rowNum += pageSize;
                keepGoing = allRows.length < totalRows && allRows.length > 0;
            } while (keepGoing);

            const gridDiv = document.createElement('div');
            gridDiv.style.display = 'none';
            document.body.appendChild(gridDiv);
            const exportColumns = this.buildColumns().map(col => {
                const newCol = { ...col };
                delete newCol.cellRenderer;
                if (newCol.field === 'id') {
                    newCol.valueFormatter = (params) => params.value;
                }
                // Remove flagged cellRenderer for export since it will error
                if (newCol.cellRenderer === 'flagged') {
                    delete newCol.cellRenderer;
                    delete newCol.cellRendererParams;
                }
                return newCol;
            });
            const gridOptions: GridOptions = {
                columnDefs: exportColumns,
                rowData: allRows,
                excelStyles: this.formatter.excelStyles,
                defaultColDef: this.formatter.defaultColDef,
                rowModelType: 'clientSide'
            };
            //new Grid(gridDiv, gridOptions);
           /* const api: any = gridOptions.api!;*/
            const nowRaw = this.datePipe.transform(new Date(), "yyyy-MM-dd");
            const now = nowRaw ? nowRaw.toString() : "";
            let fileName = 'Wells_Requiring_FA_Report';
            fileName = `${fileName}_${now}`;
            this.formatter.exportDataToExcel(fileName, 'Wells', this.gridApi, false);
        } finally {
            this.loading = false;
            this.loader.toggleLoader(this.loading);
        }
    }



}


class WellsDataSource {
    constructor(private wellService: WellService,
        public dispositionDomains: DomainValue[], public wellTypeDomains: DomainValue[],
        public wellTypeDescDomains: DomainValue[], public legacyTrackingDomain: DomainValue[],
        public formationsDomain: DomainValue[], public searchSpec: PagedWellSearchSpec = {} as PagedWellSearchSpec) { }

    getRows(params: IServerSideGetRowsParams) {
        this.searchSpec = this.handleFiltering(params);

        let ascending: boolean = true;
        if (params.request.sortModel && params.request.sortModel.length > 0) {
            ascending = params.request.sortModel[0].sort === "asc";
            this.searchSpec.ordering = {
                ascending: ascending,
                field: params.request.sortModel[0].colId
            } as OrderParameters;
        }

        this.wellService.getWellsPaged(this.searchSpec).subscribe({
			next: (response) => {
				let successParams: LoadSuccessParams = {
					rowData: response.item1,
					rowCount: response.item2
				};
				params.success(successParams);
            },
            error: (error) => {
                params.fail();
            }
        });
    }

    handleFiltering(params: IServerSideGetRowsParams): PagedWellSearchSpec {
        var spec: PagedWellSearchSpec = {};
        if (params && params.request) {
            spec.rowNumber = params.request.startRow;
            spec.perPage = params.request.endRow - params.request.startRow;
        }
        if (params && params.request && params.request.filterModel) {
            const filterModel = params.request.filterModel;
            //Custom logic for fields that don't string match properties in the spec
            if (filterModel['id'] && filterModel['id'].filter) {
                spec.api_Number = filterModel['id'].filter;
                spec.api_Number_Operator = filterModel['id'].type;
            }

            // wellNumber → number
            if (filterModel['wellNumber'] && filterModel['wellNumber'].filter) {
                spec.number = filterModel['wellNumber'].filter;
                spec.number_Operator = filterModel['wellNumber'].type;
            }

            // countyName → county_Name
            if (filterModel['countyName'] && filterModel['countyName'].filter) {
                spec.county_Name = filterModel['countyName'].filter;
                spec.county_Name_Operator = filterModel['countyName'].type;
            }

            // townshipName → township_Name
            if (filterModel['townshipName'] && filterModel['townshipName'].filter) {
                spec.township_Name = filterModel['townshipName'].filter;
                spec.township_Name_Operator = filterModel['townshipName'].type;
            }

            // Custom logic for domain value properties
            if (filterModel['disposition'] && filterModel['disposition'].values) {
                if (filterModel['disposition'].values.includes('')) {
                    spec.disposition = 'BLANK'; // Signal to backend for empty/null
                } else {
                    spec.disposition = this.dispositionDomains
                        .filter(domain => filterModel['disposition'].values.includes(domain.Definition))
                        .map(d => d.Definition)
                        .join(',');
                }
            }
            if (filterModel['wellType'] && filterModel['wellType'].values) {
                if (filterModel['wellType'].values.includes('')) {
                    spec.wellType = 'BLANK';
                } else {
                    spec.wellType = this.wellTypeDomains
                        .filter(domain => filterModel['wellType'].values.includes(domain.Definition))
                        .map(d => d.Definition)
                        .join(',');
                }
            }
            if (filterModel['wellTypeDescription'] && filterModel['wellTypeDescription'].values) {
                if (filterModel['wellTypeDescription'].values.includes('')) {
                    spec.wellTypeDescription = 'BLANK';
                } else {
                    spec.wellTypeDescription = this.wellTypeDescDomains
                        .filter(domain => filterModel['wellTypeDescription'].values.includes(domain.Definition))
                        .map(d => d.Definition)
                        .join(',');
                }
            }
            if (filterModel['legacyTracking'] && filterModel['legacyTracking'].values) {
                if (filterModel['legacyTracking'].values.includes('')) {
                    spec.legacyTracking = 'BLANK';
                } else {
                    spec.legacyTracking = this.legacyTrackingDomain
                        .filter(domain => filterModel['legacyTracking'].values.includes(domain.Definition))
                        .map(d => d.Definition)
                        .join(',');
                }
            }
            if (filterModel['proposedFormation'] && filterModel['proposedFormation'].values) {
                if (filterModel['proposedFormation'].values.includes('')) {
                    spec.proposedFormation = 'BLANK';
                } else {
                    spec.proposedFormation = this.formationsDomain
                        .filter(domain => filterModel['proposedFormation'].values.includes(domain.Definition))
                        .map(d => d.Definition)
                        .join(',');
                }
            }
            if (filterModel['deepestFormationPenetrated'] && filterModel['deepestFormationPenetrated'].values) {
                if (filterModel['deepestFormationPenetrated'].values.includes('')) {
                    spec.deepestFormationPenetrated = 'BLANK';
                } else {
                    spec.deepestFormationPenetrated = this.formationsDomain
                        .filter(domain => filterModel['deepestFormationPenetrated'].values.includes(domain.Definition))
                        .map(d => d.Definition)
                        .join(',');
                }
            }
            // Fallback for other filters, including date filters
            for (const key in filterModel) {
                if (!filterModel.hasOwnProperty(key)) continue;
                // Skip domain value properties already handled
                if ([
                    'disposition',
                    'wellType',
                    'wellTypeDescription',
                    'legacyTracking',
                    'proposedFormation',
                    'deepestFormationPenetrated'
                ].includes(key)) continue;
                if (filterModel[key].hasOwnProperty('values')) {
                    (spec as any)[key] = filterModel[key].values;
                } else if (filterModel[key].hasOwnProperty('filter')) {
                    (spec as any)[key] = filterModel[key].filter;
                    if (filterModel[key].hasOwnProperty('type')) {
                        (spec as any)[`${key}_Operator`] = filterModel[key].type;
                    }
                } else if (filterModel[key].filterType === 'date') {
                    // Handle AG Grid date filter
                    (spec as any)[key] = filterModel[key].dateFrom;
                    (spec as any)[`${key}_Operator`] = filterModel[key].type; // e.g., 'equals', 'lessThan', etc.
                }
            }
        }
        return spec;
    }
}